import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import Servidor from "../config/Servidor";
import "./VerUsuario.css";

export default function VerUsuario() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [usuario, setUsuario] = useState(null);
  const [clientes, setClientes] = useState([]);
  const [caja, setCaja] = useState([]);
  const [gastos, setGastos] = useState([]);
  const [liquidaciones, setLiquidaciones] = useState([]);
  const [retiros, setRetiros] = useState([]);
  const [inyectados, setInyectados] = useState([]);
  const [loading, setLoading] = useState(true);

  const [modalCliente, setModalCliente] = useState(null); // Para mostrar tarjetas de un cliente
  const [modalTarjeta, setModalTarjeta] = useState(null); // Para mostrar cobros y abonos de una tarjeta
  const [vista, setVista] = useState("clientes");
  const [modal, setModal] = useState(null);

  useEffect(() => {
    async function fetchData() {
      try {
        const resUsuario = await axios.get(`${Servidor.IP}/usuario/${id}`);
        setUsuario(resUsuario.data.usuario);

        setClientes((await axios.get(`${Servidor.IP}/clientes/${id}`)).data.clientes || []);
        setCaja((await axios.get(`${Servidor.IP}/caja/${id}`)).data.caja || []);
        setGastos((await axios.get(`${Servidor.IP}/gastos/${id}`)).data.gastos || []);
        setLiquidaciones((await axios.get(`${Servidor.IP}/liquidacion/${id}`)).data.liquidacion || []);
        setRetiros((await axios.get(`${Servidor.IP}/retiro/${id}`)).data.retiro || []);
        setInyectados((await axios.get(`${Servidor.IP}/inyectado/${id}`)).data.inyectado || []);

      } catch (err) {
        alert("Error al cargar datos: " + err.message);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, [id]);

  if (loading) return <p>Cargando...</p>;
  if (!usuario) return <p>Usuario no encontrado</p>;

  const formatDate = (d) => (d ? new Date(d).toLocaleDateString() : "-");

  // Convierte #AARRGGBB (Flutter) a #RRGGBB (Web)
const flutterToWebColor = (flutterColor) => {
  if (!flutterColor || flutterColor.length !== 9) return flutterColor;

  const r = flutterColor.substring(3, 5);
  const g = flutterColor.substring(5, 7);
  const b = flutterColor.substring(7, 9);

  return `#${r}${g}${b}`;
};
  // Abrir modal de un cliente mostrando sus tarjetas
  const openClienteModal = async (cliente) => {
    try {
      // 🔹 Traer tarjetas por cliente
      const res = await axios.get(`${Servidor.IP}/tarjetas/cliente/${cliente.id_cliente}`);
      setModalCliente({ cliente, tarjetas: res.data.tarjetas || [] });
    } catch (err) {
      alert("Error al cargar tarjetas: " + err.message);
    }
  };

  // Abrir modal de tarjeta mostrando cobros y abonos
  const openTarjetaModal = async (tarjeta) => {
    try {
      const resCobros = await axios.get(`${Servidor.IP}/cobros/tarjeta/${tarjeta.id_tarjeta}`);
      const resAbonos = await axios.get(`${Servidor.IP}/abonos/tarjeta/${tarjeta.id_tarjeta}`);
      setModalTarjeta({
        tarjeta,
        cobros: resCobros.data.cobros || [],
        abonos: resAbonos.data.abonos || [],
      });
    } catch (err) {
      alert("Error al cargar cobros/abonos: " + err.message);
    }
  };

  return (
    <div className="user-view-container">

      {/* VOLVER */}
      <button className="volver" onClick={() => navigate("/ListaUsuarios")}>⬅ Volver</button>

      {/* TARJETA DEL USUARIO */}
      <div className="card usuario-card">
        <h1>{usuario.persona_nombre} {usuario.primerapellido}</h1>
        <div className="user-info">
          <img
            className="foto-user"
            src={`/uploads/${usuario.foto}`}
            alt="Foto"
            onError={(e) => (e.target.style.display = "none")}
          />
          <div className="info-col">
            <h2>Datos de Persona</h2>
            <div className="datos-grid">
              <div><strong>Nombre:</strong> {usuario.persona_nombre}</div>
              <div><strong>Apellidos:</strong> {usuario.primerapellido} {usuario.segundoapellido}</div>
              <div><strong>Cédula:</strong> {usuario.cedula}</div>
              <div><strong>Celular:</strong> {usuario.celular}</div>
              <div><strong>Fecha Nac:</strong> {formatDate(usuario.fechan)}</div>
            </div>

            <h2>Datos de Usuario</h2>
            <div className="datos-grid">
              <div><strong>ID:</strong> {usuario.id_usuario}</div>
              <div><strong>Usuario:</strong> {usuario.usuario}</div>
              <div><strong>Contraseña:</strong> {usuario.contraseña}</div>
              <div><strong>Fecha:</strong> {formatDate(usuario.fecha)}</div>
              <div><strong>Vence:</strong> {formatDate(usuario.fecha_vencimiento)}</div>
              <div><strong>Meses Pagados:</strong> {usuario.meses_pagados}</div>
              <div><strong>Activo:</strong> {usuario.activo ? "✔" : "✘"}</div>
              <div><strong>Rol:</strong> {usuario.id_rol}</div>
              <div><strong>Supervisor:</strong> {usuario.id_supervisor || "-"}</div>
              <div><strong>Lat:</strong> {usuario.latitud}</div>
              <div><strong>Lng:</strong> {usuario.longitud}</div>
              <div><strong>Ingreso:</strong> {usuario.ingreso || "-"}</div>
              <div><strong>Pend Tema:</strong> {usuario.pendiente_tema}</div>
            </div>

            <h2>Tema</h2>
            <div
              className="tema-circle"
              style={{
               background: `conic-gradient(
  ${flutterToWebColor(usuario.color1) || "#ccc"} 0deg 90deg,
  ${flutterToWebColor(usuario.color2) || "#eee"} 90deg 180deg,
  ${flutterToWebColor(usuario.color3) || "#ddd"} 180deg 270deg,
  ${flutterToWebColor(usuario.color4) || "#bbb"} 270deg 360deg
)`,
              }}
            ></div>
          </div>
        </div>
      </div>

      {/* PESTAÑAS */}
      <div className="tabs">
        <button className={vista === "clientes" ? "active" : ""} onClick={() => setVista("clientes")}>
          Clientes
        </button>
        <button className={vista === "movimientos" ? "active" : ""} onClick={() => setVista("movimientos")}>
          Movimientos
        </button>
      </div>

      {/* CONTENIDO */}
      <div className="contenido">

        {/* CLIENTES */}
        {vista === "clientes" && (
          <div className="clientes-list">
            {clientes.length === 0 ? (
              <p>Sin clientes</p>
            ) : (
              clientes.map((c) => (
                <div className="card cliente-card" key={c.id_cliente}>
                  <h3>{c.nombreCliente}</h3>
                     <p><strong>id:</strong> {c.id_cliente} / <strong>Cédula: </strong> {c.cedula}</p>
                  <p><strong>Telefono:</strong> {c.telefono} / <strong>direccion: </strong> {c.barrio}</p>
                    <p><strong>negocio:</strong> {c.negocio}</p>
                  <div className="cliente-botones">
                    <button onClick={() => openClienteModal(c)}>Ver Tarjetas</button>
                  </div>
                </div>
              ))
            )}
          </div>
        )}

        {/* MODALES DE MOVIMIENTOS */}
        {vista === "movimientos" && (
          <div className="mov-cuadrados-container">
            <div className="mov-grid">
              <div className="mov-card" onClick={() => setModal({ tipo: "Caja", data: caja })}>Caja</div>
              <div className="mov-card" onClick={() => setModal({ tipo: "Gastos", data: gastos })}>Gastos</div>
              <div className="mov-card" onClick={() => setModal({ tipo: "Liquidaciones", data: liquidaciones })}>Liquidaciones</div>
              <div className="mov-card" onClick={() => setModal({ tipo: "Retiros", data: retiros })}>Retiros</div>
              <div className="mov-card" onClick={() => setModal({ tipo: "Inyectados", data: inyectados })}>Inyectados</div>
            </div>

            {/* MODAL MOVIMIENTOS */}
            {modal && (
              <div className="modal-overlay" onClick={() => setModal(null)}>
                <div className="modal-content" onClick={e => e.stopPropagation()}>
                  <h3 className="modal-title">{modal.tipo}</h3>
                  <div className="modal-lista">
                    {modal.data.length === 0 ? <p>No hay datos</p> :
                      modal.data.map((item, i) => (
                        <div className="modal-item" key={i}>
                          {/* ... Aquí mantienes tu render de Caja, Gastos, etc ... */}
                          {modal.tipo === "Caja" && (
                            <>
                              <p>Id Caja: {item.id_caja} | Ultima fecha liquidada: {item.ultima_fecha_liquidada}</p>
                              <p>Caja Ultima Liquidada: {item.caja_ultima_liquidada} | Caja actual: {item.caja_actual}</p>
                              <p>Estimado cobrar: {item.estimado_cobrar} | Total cobrado: {item.total_cobrado}</p>
                              <p>Liquidada total: {item.liquidada_total} | cobro dia: {item.cobro_dia}</p>
                              <p>total ventas: {item.total_ventas} | gastos: {item.gastos}</p>
                              <p>ganancia: {item.ganancia} | id usuario: {item.id_usuario}</p>
                            </>
                          )}
                   
                          {modal.tipo === "Gastos" && (
                            <>
                               <p>Monto: {item.valor}</p>
                              <p>descripcion: {item.descripcion}</p>
                              <p>Fecha: {formatDate(item.fecha)}</p>
                            </>
                          )}

                          {modal.tipo === "Liquidaciones" && (
                            <>
                             <p>Fecha: {formatDate(item.fecha_liquidada)}</p>
                                <p>caja liquidada: {item.caja_liquidada}</p>
                              <p>Total Cobrado: {item.total_cobrado}</p>
                              <p>Total Ventas: {item.total_ventas}</p>
                              <p>Total gastos: {item.total_gastos}</p>
                            </>
                          )}

                          {modal.tipo === "Retiros" && (
                            <>
                              <p>Monto: {item.monto}</p>
                              <p>Fecha: {formatDate(item.fecha)}</p>
                                 <p>descripcion: {item.descripcion}</p>
                            </>
                          )}

                          {modal.tipo === "Inyectados" && (
                            <>
                              <p>Monto: {item.monto}</p>
                              <p>Fecha: {formatDate(item.fecha)}</p>
                                 <p>descripcion: {item.descripcion}</p>
                            </>
                          )}
                        </div>
                      ))
                    }
                  </div>
                  <button className="modal-cerrar" onClick={() => setModal(null)}>Cerrar</button>
                </div>
              </div>
            )}
          </div>
        )}

        {/* MODAL CLIENTE - MOSTRAR TARJETAS */}
        {modalCliente && (
          <div className="modal-overlay" onClick={() => setModalCliente(null)}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
              <h3>{modalCliente.cliente.nombreCliente} - Tarjetas</h3>
              <div className="modal-lista">
                {modalCliente.tarjetas.length === 0 ? (
                  <p>No hay tarjetas</p>
                ) : (
                  modalCliente.tarjetas.map(t => (
                    <div key={t.id_tarjeta} className="modal-item" onClick={() => openTarjetaModal(t)}>
                      <p><strong>ID Tarjeta:</strong> {t.id_tarjeta}</p>
                      <p><strong>fecha inicio :</strong>{formatDate(t.fechainicial)} / <strong>fecha inicio :</strong> {formatDate(t.fechafinal)}</p>
                      <p><strong>valor :</strong> {t.valor} / <strong>cuotas :</strong>  {t.cuotas}</p>
                       <p><strong>deuda :</strong> {t.deudaactual} / <strong>atraso :</strong>  {t.diasatrazo}</p>
                      <p><strong>cuotas :</strong> {t.cuotas_pagadas} / <strong>abonos :</strong>  {t.cuotas_abono}</p>
                    </div>
                  ))
                )}
              </div>
              <button className="modal-cerrar" onClick={() => setModalCliente(null)}>Cerrar</button>
            </div>
          </div>
        )}

   {/* MODAL TARJETA - COBROS Y ABONOS */}
{modalTarjeta && (
  <div className="modal-overlay" onClick={() => setModalTarjeta(null)}>
    <div className="modal-content" onClick={e => e.stopPropagation()}>
      <h3>Tarjeta {modalTarjeta.tarjeta.id_tarjeta}</h3>

      <div className="cobros-abonos-container">
        {/* COBROS */}
        <div className="cobros-list">
          <h4>Cobros</h4>
          {modalTarjeta.cobros.length === 0 ? <p>Sin cobros</p> :
            modalTarjeta.cobros.map(c => (
              <div key={c.id_cobro} className="modal-item">
                <p>Monto: {c.monto}</p>
                <p>Fecha: {formatDate(c.fecha)}</p>
              </div>
            ))
          }
        </div>

        {/* ABONOS */}
        <div className="abonos-list">
          <h4>Abonos</h4>
          {modalTarjeta.abonos.length === 0 ? <p>Sin abonos</p> :
            modalTarjeta.abonos.map(a => (
              <div key={a.id_abono} className="modal-item">
                <p>Monto: {a.monto}</p>
                <p>Fecha: {formatDate(a.fecha)}</p>
              </div>
            ))
          }
        </div>
      </div>

      <button className="modal-cerrar" onClick={() => setModalTarjeta(null)}>Cerrar</button>
    </div>
  </div>
)}


      </div>
    </div>
  );
}
